import { clearError } from "../../domain/error/errorModel";
import { UpdateErrorStore, updateErrorUseCase } from "./updateErrorUseCase";

const clearErrorUseCase = (store: UpdateErrorStore) =>
    updateErrorUseCase(store, clearError);

export { clearErrorUseCase }